<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading" @on-cancel="cancel" >
      <h3 slot="header" class="modal-header">{{'添加自如员工'}}</h3>
      <div>
        <Form :model="formData" :label-width="90" :rules="formRules"  ref="formData">
          <FormItem label="系统号：" prop="uid">
            <Input v-model="formData.uid" class="item-width" @on-blur="getZoInfo" ></Input>
          </FormItem>
          <FormItem label="员工姓名：" prop="nickName">
            <Input :disabled="true" v-model="formData.nickName" class="item-width" ></Input>
          </FormItem>
          <FormItem label="职位：" prop="position">
                <Select placeholder="请选择" v-model="formData.position" class="item-width">
                  <Option v-for="item in positionOptions" :value="item.value" :key="item.value">{{item.name}}</Option>
                </Select>
              </FormItem>
          <FormItem label="所属机构" class="ivu-form-item-required">
            <a href="javascript:void(0)" @click.stop="addOrg">{{titleArr.length > 0?titleArr:'添加组织机构'}}</a>
          </FormItem>
<!--          <FormItem label="系统角色" class="ivu-form-item-required">-->
<!--            <a href="javascript:void(0)" @click.stop="addChara(1)">{{roleNameArr.length > 0?roleNameArr:'添加盘古系统角色'}}</a>-->
<!--          </FormItem>-->
          <FormItem label="系统角色"  class="ivu-form-item-required">
            <a href="javascript:void(0)" @click.stop="addChara(3)">{{newroleNameArr.length > 0?newroleNameArr:'添加系统角色'}}</a>
          </FormItem>
          <!--<FormItem label="超级zo角色">-->
            <!--<a href="javascript:void(0)" @click.stop="addChara(2)">{{zoRoleNameArr.length > 0?zoRoleNameArr:'添加超级zo角色'}}</a>-->
          <!--</FormItem>-->
          <!--<FormItem label="marketing角色">-->
            <!--<a href="javascript:void(0)" @click.stop="addChara(4)">{{zoRoleNameArr.length > 0?zoRoleNameArr:'添加marketing系统角色'}}</a>-->
          <!--</FormItem>-->

        </Form>
        <add-org :n="orgN" :valueArrStr="valueArr" @setTitleValueArr="setTitleValueArr"></add-org>
        <CharacterList :n="charaN" :roleIdArrStr="allRoleValueArr" :appType="appType" @getRole="getRoles" ></CharacterList>
      </div>
    </Modal>
  </div>


</template>
<script>
  import AddOrg from './AddOrg'
  import CharacterList from './CharacterList'
  import {addZiroomEmployee} from "../../../../api/user";
  import { getEHRUserDetail } from 'api/managementCenter'

  export default {
    name: "",
    components: {
      AddOrg,
      CharacterList
    },
    props: {
      n: {
        type: Number,
        default: 0
      },
      positionOptions: {
        type: Array,
        default: () => []
      }
    },
    watch: {
      n() {
        this.clearData();
        this.isShow = true
      }
    },
    data() {
      return {
        charaN: 0,
        appType:0,
        orgN: 0,
        titleArr:'',
        valueArr:'',
        allRoleValueArr:'',
        newroleValueArr:'',
        newroleNameArr:'',
        roleValueArr:'',
        roleNameArr:'',
        zoRoleValueArr:'',
        zoRoleNameArr:'',
        loading: true,
        isShow: false,
        formData: {
          uid: '',
          nickName: '',
          organUids:'',
          roleIds:'',
          zoRoleIds:'',
          position: ''
        },
        formRules: {
          uid: [{required: true, message: ' ', trigger: 'blur', type: 'string'}],
          nickName: [{required: true, message: ' ', trigger: 'blur', type: 'string'}],
          position: [{ required: true, message: '请选择职位信息', trigger: 'change' }]
        },
      }
    },
    methods: {
      clearData(){
        this.formData={
          uid: '',
          nickName: '',
          organUids:'',
          roleIds:'',
          zoRoleIds:'',
        };
        this.newroleNameArr='';
        this.newroleValueArr=''
        this.titleArr='';
        this.valueArr='';
        this.allRoleValueArr='';
        this.roleValueArr='';
        this.roleNameArr='';
        this.zoRoleValueArr='';
        this.zoRoleNameArr='';
        this.$refs['formData'] &&  this.$refs['formData'].resetFields()
      },
      getZoInfo(){
        if(this.formData.uid){
          getEHRUserDetail({userCode:this.formData.uid}).then( res => {
            if(res.data.name){
              this.formData.nickName = res.data.name
            } else {
              this.formData.nickName = ''
              this.$Message.info('该系统号不存在！')
            }
          })
        }
      },
      addChara(params) {
        this.appType = params
        if(params === 1){
          this.allRoleValueArr = this.roleValueArr
        }
        if(params === 2){
          this.allRoleValueArr = this.zoRoleValueArr
        }
        if(params===3){
          this.allRoleValueArr = this.newroleValueArr

        }
        this.charaN++
      },
      addOrg() {
        this.orgN++
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        if(!this.valueArr){
          this.$Message.info('请添加组织机构！');
          this.changeLoading();
          return
        }
        if(!this.newroleValueArr){
          this.$Message.info('请添加角色！');
          this.changeLoading();
          return
        }
        this.$refs['formData'].validate(bool => {
          if (bool) {
            this.formData.organUids = this.valueArr;
            this.formData.roleIds = this.roleValueArr;
            this.formData.zoRoleIds = this.zoRoleValueArr;
            this.formData.newRoleIds=this.newroleValueArr;
            addZiroomEmployee(this.formData).then(res=>{
                this.$Message.success('添加自如用户成功');
                this.$emit('done')

              }).catch(error=>{

              }).finally(()=>{
                this.isShow=false
              })
          }
          else {
            this.changeLoading()
          }
        })
      },
      cancel() {
        this.isShow = false
      },
      setTitleValueArr(params){

        const title=[];
        const value=[];
        params.forEach(ele=>{
          title.push(ele.title);
          value.push(ele.value)

        });
        this.titleArr = title.join(',');
        this.valueArr = value.join(',')
      },
      getRoles(params) {
        if(this.appType == 1){
          this.roleValueArr = params.roleValueArr.join(',');
          this.roleNameArr = params.roleNameArr.join(',')
        }
        if(this.appType == 2){
          this.zoRoleValueArr = params.roleValueArr.join(',');
          this.zoRoleNameArr = params.roleNameArr.join(',')
        }
        if(params.appType === 3){
          this.newroleValueArr = params.roleValueArr.join(',');
          this.newroleNameArr = params.roleNameArr.join(',')
          return
        }

      },

    }

  }
</script>

<style scoped>
  .item-width {
    width: 280px;
  }


</style>
